import { defineMessages } from '@transcend-io/internationalization';

export const footerMessages = defineMessages(
  'privacy-center.containers.Footer.footer',
  {
    aboutTranscend: {
      defaultMessage: 'Our Approach to Privacy',
      description: 'Text for link to about Transcend page in the footer.',
    },
    support: {
      defaultMessage: 'Contact Support',
      description: 'Text for contacting support in the footer.',
    },
    mainSite: {
      defaultMessage: 'Return to Main Site',
      description:
        'Text to display when returning to main site from footer of Privacy Center.',
    },
    linkToTranscend: {
      defaultMessage: 'Navigate to Transcend homepage',
    },
  },
);
